import React from 'react';
import MenuItem from '@mui/material/MenuItem';
import {
    AccordionSetting,
    AccordionSettingDetail,
    AccordionSettingSummary,
    AccordionSummaryValue,
    CustomMenuItem,
    SettingCheckbox,
    SettingLabel,
    SettingSubHeader,
} from 'ff/debrief/components/map/settings/shared';
import { useMapSettings } from 'ff/debrief/hooks';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

export const AirwaySettings: React.FC = () => {
    const { currentSettings, settingsUI, toggleAccordion, toggleMapSetting } =
        useMapSettings();
    return (
        <CustomMenuItem>
            <AccordionSetting
                expanded={settingsUI?.accordionsExpanded?.airways}
                onChange={() => toggleAccordion('airways')}
            >
                <AccordionSettingSummary expandIcon={<ExpandMoreIcon />}>
                    <SettingLabel>Airways</SettingLabel>
                    <AccordionSummaryValue>
                        {currentSettings?.filters?.navlevel}
                    </AccordionSummaryValue>
                </AccordionSettingSummary>
                <AccordionSettingDetail>
                    <MenuItem>
                        <SettingCheckbox
                            id="lowAirways"
                            displayName="Low"
                            checked={
                                currentSettings?.filters?.navlevel === 'low'
                            }
                            onChange={e => {
                                const value = e.target.checked ? 'low' : false;
                                toggleMapSetting({
                                    settingName: 'airways',
                                    value: value,
                                });
                            }}
                        />
                    </MenuItem>
                    <MenuItem>
                        <SettingCheckbox
                            id="highAirways"
                            displayName="High"
                            checked={
                                currentSettings?.filters?.navlevel === 'high'
                            }
                            onChange={e => {
                                const value = e.target.checked ? 'high' : false;
                                toggleMapSetting({
                                    settingName: 'airways',
                                    value: value,
                                });
                            }}
                        />
                    </MenuItem>
                    <SettingSubHeader>Customize Airways</SettingSubHeader>
                    <MenuItem>
                        <SettingCheckbox
                            displayName="Airways"
                            checked={currentSettings?.filters?.airways}
                            onChange={e => {
                                toggleMapSetting({
                                    settingName: 'airways',
                                    value: e.target.checked,
                                });
                            }}
                        />
                    </MenuItem>
                    <MenuItem>
                        <SettingCheckbox
                            displayName="Navaids"
                            checked={currentSettings?.filters?.navaids}
                            onChange={e => {
                                toggleMapSetting({
                                    settingName: 'navaids',
                                    value: e.target.checked,
                                });
                            }}
                        />
                    </MenuItem>
                    <MenuItem>
                        <SettingCheckbox
                            displayName="Waypoints"
                            checked={currentSettings?.filters?.waypoints}
                            onChange={e => {
                                toggleMapSetting({
                                    settingName: 'waypoints',
                                    value: e.target.checked,
                                });
                            }}
                        />
                    </MenuItem>
                </AccordionSettingDetail>
            </AccordionSetting>
        </CustomMenuItem>
    );
};
